import axios from 'axios';

export function patchAdvertiserOnboarding(token, body) {
    return axios.patch(`${process.env.REACT_APP_API_URL}/advertiser/onboarding`, body, {
        headers: { Authorization: token }
    });
}
